import React, { useEffect } from 'react';
import {
  Flex,
  Box,
  Heading,
  Text,
  VStack,
  Spinner,
  useColorModeValue,
  Alert,
  AlertIcon,
  Link
} from '@chakra-ui/react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const VerifyEmail = () => {
  const { user, isLoading } = useAuth0();
  const navigate = useNavigate();
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');

  useEffect(() => {
    if (!isLoading && user?.email_verified) {
      navigate('/jobs/dashboard');
    }
  }, [user, isLoading, navigate]);

  return (
    <Flex minH="100vh" align="center" justify="center" bg={bgColor}>
      <Box
        w="full"
        maxW="md"
        p={8}
        borderRadius="lg"
        boxShadow="lg"
        bg={cardBg}
      >
        <VStack spacing={6} align="stretch">
          <Box textAlign="center">
            <Heading as="h1" size="xl" mb={2}>
              Verify Your Email
            </Heading>
            {isLoading ? (
              <Spinner size="xl" />
            ) : (
              <>
                <Text mb={4}>
                  We've sent a verification link to:
                  <br />
                  <strong>{user?.email}</strong>
                </Text>
                <Alert status="warning" borderRadius="md">
                  <AlertIcon />
                  Check your spam folder if you don't see it
                </Alert>
                <Text mt={4} color="gray.500">
                  Already verified?{' '}
                  <Link color="blue.500" href="/login">
                    Try logging in
                  </Link>
                </Text>
              </>
            )}
          </Box>
        </VStack>
      </Box>
    </Flex>
  );
};

export default VerifyEmail;